import React, { JSX } from 'react';
import classNames from 'classnames';
import {
    CarouselProvider,
    Slider,
    Slide,
    ButtonBack,
    ButtonNext,
    DotGroup,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { ButtonBackSvg, ButtonNextSvg } from '../jsxElements';
import styles from './GenericCarousel.module.css';

const MIN_SLIDES_FOR_CAROUSEL = 4;

export function displayFullCarousel(listLength: number) {
    return listLength >= MIN_SLIDES_FOR_CAROUSEL;
}

const GenericCarousel: React.FC<{
    elements: JSX.Element[];
}> = ({ elements }) => {
    if (!displayFullCarousel(elements.length)) {
        return (
            <div>
                {elements.map((value, idx) => (
                    <div
                        key={`element-container-${idx}`}
                        className={styles.carouselSpacer}
                    >
                        {value}
                    </div>
                ))}
            </div>
        );
    }
    const slides = elements.map((value, idx) => (
        <Slide key={`slide-${idx}`} index={idx}>
            {value}
        </Slide>
    ));
    return (
        <CarouselProvider
            naturalSlideWidth={100}
            naturalSlideHeight={100}
            totalSlides={slides.length}
            visibleSlides={1}
            isIntrinsicHeight={true}
            className={classNames(
                styles.carouselProvider,
                styles.carouselSpacer
            )}
        >
            <Slider>{slides}</Slider>
            <ButtonBack
                className={classNames(
                    styles.carouselNavigateButton,
                    styles.carouselBackNavigateButton
                )}
            >
                <ButtonBackSvg />
            </ButtonBack>
            <ButtonNext
                className={classNames(
                    styles.carouselNavigateButton,
                    styles.carouselNextNavigateButton
                )}
            >
                <ButtonNextSvg />
            </ButtonNext>
            <DotGroup disableActiveDots={false} />
        </CarouselProvider>
    );
};

export default GenericCarousel;
